import { render, staticRenderFns } from "./StockCorrectionItems.vue?vue&type=template&id=75801ca1&scoped=true&"
import script from "./StockCorrectionItems.vue?vue&type=script&lang=ts&"
export * from "./StockCorrectionItems.vue?vue&type=script&lang=ts&"
import style0 from "./StockCorrectionItems.vue?vue&type=style&index=0&id=75801ca1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75801ca1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCombobox,VSimpleTable,VTextField})
